import { render, staticRenderFns } from "./index.vue?vue&type=template&id=00dc6506&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00dc6506')) {
      api.createRecord('00dc6506', component.options)
    } else {
      api.reload('00dc6506', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=00dc6506&", function () {
      api.rerender('00dc6506', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shop/index.vue"
export default component.exports